module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vVm6xM/tc-custom/9781614234227.jpg?1726519427072",
      "alt": "This image is the cover for the book Missouri's Haunted Route 66, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Missouri's Haunted Route 66, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Ride shotgun with the author of "), _c('i', [_vm._v("Haunted Ozarks")]), _vm._v(" on this scary road trip across Missouri’s stretch of the “Main Street of America.”")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Alongside the nostalgic appeal of Route 66 lurk ghostly roadside hitchhikers, the Goatman of Rolla, amusement park spirits, the Civil War–dead, and the shadows thrown by the mighty Thunderbird. Spanning three hundred dangerously curving miles, the stretch of the Mother Road in Missouri earned the title of “Bloody 66,” and some of its stopping places are marked by equally grim history. The Lemp Mansion saw family members commit suicide one by one. Springfield’s Pythian Castle was an orphanage before becoming a military hospital and housing World War II prisoners of war. Follow Janice Tremeear as she takes a detour down Zombie Road, peers into the matter of the Joplin Spook Light and even stays overnight in Missouri’s most haunted locations to discover what makes the Show Me State such a lively place for the dead.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Janice Tremeear\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Haunted America\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0